import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1199px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            console.log('test');
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'team-slider': 'team-carousel',
    'team-slider-desktop': 'team-carousel-desktop',
    'grid-videos': 'videos-carousel',
    'our-team': 'team-sidebar-widget',
    'news-blog-slider': 'news-blog-carousel',
    'spanish-case-result-slider': 'spanish-case-result-slider',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

const coloradoSwitch = document.getElementById("colorado-switch");
const texasSwitch = document.getElementById("texas-switch");
const coloradoSection = document.querySelector(".location-footer__colorado");
const texasSection = document.querySelector(".location-footer__texas");

if(coloradoSwitch) {
    coloradoSwitch.addEventListener("click", () => {
        texasSection.style.display = "none";
        coloradoSection.style.display = "flex";
        coloradoSwitch.classList.add("active");
        texasSwitch.classList.remove("active");
    });
}
if(texasSwitch) {
    texasSwitch.addEventListener("click", () => {
        coloradoSection.style.display = "none";
        texasSection.style.display = "flex";
        texasSwitch.classList.add("active");
        coloradoSwitch.classList.remove("active");
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const firstAccordionItem = document.querySelector('.cw-accordion__item');
    if (firstAccordionItem) {
      firstAccordionItem.classList.add('cw-accordion__item--open');
      
      const firstAccordionButton = firstAccordionItem.querySelector('.cw-accordion__item-title');
      if (firstAccordionButton) {
        firstAccordionButton.setAttribute('aria-expanded', 'true');
      }
      
      const firstAccordionContent = firstAccordionItem.querySelector('.cw-accordion__item-content');
      if (firstAccordionContent) {
        firstAccordionContent.setAttribute('role', 'region');
        firstAccordionContent.setAttribute('aria-labelledby', firstAccordionButton.id);
      }
    }
  });
  
  document.addEventListener('DOMContentLoaded', () => {

    const bacCalcTemplate = document.querySelector('.page-template-bac-calc');

    if(bacCalcTemplate) {
        class WidmarkFormula {
            constructor() {
                this.submitCounter = 0;
                this.init();
            }

            bacCalculations() {
                document.getElementById('bac-form').addEventListener('submit', (event) => {
                    event.preventDefault();

                    const inputAlcohols = document.querySelectorAll('.input-alcohol');
                    let blankInputAlcoholCounter = 0;
                    let rotateResult = 0;

                    const weight = document.getElementById('weight').value;

                    if (weight == 0 || weight < 0) {
                        Swal('Oops...', 'Please fill in your weight', 'error');
                        return;
                    }

                    inputAlcohols.forEach((input) => {
                        if (input.value == 0 || input.value === '' || input.value < 0) {
                            blankInputAlcoholCounter++;
                        }
                    });

                    if (blankInputAlcoholCounter === 7) {
                        Swal('Oops...', 'Please fill in some ounces!', 'error');
                    } else {
                        const showScore = (start, scoreDisplay) => {
                            scoreDisplay.textContent = start.score.toFixed(2);
                        };

                        const showDescription = (BAC) => {
                            console.log(BAC);

                            const descriptions = [
                                { range: [0], selector: '.gauge-description_0' },
                                { range: [0.01, 0.03], selector: '.gauge-description_1' },
                                { range: [0.04, 0.06], selector: '.gauge-description_2' },
                                { range: [0.07, 0.09], selector: '.gauge-description_3' },
                                { range: [0.10, 0.12], selector: '.gauge-description_4' },
                                { range: [0.13, 0.15], selector: '.gauge-description_5' },
                                { range: [0.16, 0.20], selector: '.gauge-description_6' },
                                { range: [0.21, 0.30], selector: '.gauge-description_7' },
                                { range: [0.30, 0.40], selector: '.gauge-description_8' },
                                { range: [0.41], selector: '.gauge-description_9' }
                            ];

                            descriptions.forEach(description => {
                                if (BAC >= description.range[0] && BAC <= (description.range[1] || BAC)) {
                                    document.querySelector(description.selector).style.display = 'block';
                                } else {
                                    document.querySelector(description.selector).style.display = 'none';
                                }
                            });
                        };

                        const formData = {
                            weight: parseFloat(document.querySelector('input[name="weight"]').value),
                            timespent: parseFloat(document.querySelector('input[name="timespent"]').value),
                            etoh: 0,
                            avg: 0.15,
                            gender: document.querySelector('input[name="gender"]:checked').value === 'male' ? 0.68 : 0.55
                        };

                        inputAlcohols.forEach((input) => {
                            if (input.value != 0 && input.value !== '' && input.value > 0) {
                                formData.etoh += parseFloat(input.value) * (parseFloat(input.dataset.etoh) / 100);
                            }
                        });

                        const weightInKg = parseFloat((formData.weight / 2.2).toFixed(2));
                        const pureAlcohol = parseFloat((formData.etoh * 23.3).toFixed(2));
                        let BAC = parseFloat(((pureAlcohol / (weightInKg * formData.gender) - formData.avg * formData.timespent) * 0.1).toFixed(2));

                        if (BAC == Infinity) {
                            return;
                        }

                        if (BAC < 0 || BAC === 0) {
                            BAC = 0;
                            Swal('No impairment.', 'This is the only safe BAC level for driving.', 'success');
                        }

                        rotateResult = 230 * BAC / 0.41;
                        let operationTime = 2;

                        if (this.submitCounter > 0) {
                            const newRotateResult = rotateResult;
                            const newBAC = BAC;

                            rotateResult = 0;
                            BAC = 0;

                            document.querySelectorAll('.gauge-description').forEach(desc => desc.style.display = 'none');

                            TweenMax.to(document.querySelector('.indicator'), operationTime, {
                                css: { rotation: rotateResult },
                                ease: Power3.easeOut
                            });

                            setTimeout(() => {
                                rotateResult = newRotateResult;
                                BAC = newBAC;

                                if (rotateResult > 230) {
                                    rotateResult = 230;
                                }

                                TweenMax.to(document.querySelector('.indicator'), operationTime, {
                                    css: { rotation: rotateResult },
                                    ease: Power3.easeOut,
                                    onComplete: () => showDescription(BAC)
                                });

                                const start = { score: 0 };
                                const scoreDisplay = document.querySelector('.result');

                                TweenLite.to(start, operationTime, {
                                    score: BAC,
                                    onUpdate: () => showScore(start, scoreDisplay)
                                });
                            }, 2000);
                        }

                        if (rotateResult > 230) {
                            rotateResult = 230;
                        }

                        if (this.submitCounter === 0) {
                            TweenMax.to(document.querySelector('.indicator'), operationTime, {
                                css: { rotation: rotateResult },
                                ease: Power3.easeOut,
                                onComplete: () => showDescription(BAC)
                            });
                        }

                        const start = { score: 0 };
                        const scoreDisplay = document.querySelector('.result');

                        TweenLite.to(start, operationTime, {
                            score: BAC,
                            onUpdate: () => showScore(start, scoreDisplay)
                        });

                        this.submitCounter++;
                    }
                });
            }

            // mainJS() {
            //     enquire.register("screen and (min-width: 768px)", {
            //         match: () => {}
            //     });
            // }

            scrollToSection() {
                new SmoothScroll('a[href*="#"]', {
                    ignore: '[data-scroll-ignore]',
                    header: null,
                    topOnEmptyHash: true,
                    speed: 500,
                    speedAsDuration: false,
                    durationMax: null,
                    durationMin: null,
                    clip: true,
                    offset: 0,
                    updateURL: false,
                    popstate: false,
                    easing: 'easeInOutCubic',
                    customEasing: (time) => {
                        return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
                    }
                });
            }

            aosAnimation() {
                AOS.init();
            }

            init() {
                //this.mainJS();
                this.scrollToSection();
                this.bacCalculations();
                this.aosAnimation();
            }
        }

        new WidmarkFormula();
    }

});

document.addEventListener('DOMContentLoaded', () => {
    const galleryItems = document.querySelectorAll('.gallery-item');
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightbox-image');
    const lightboxClose = document.getElementById('lightbox-close');
    const lightboxPrev = document.getElementById('lightbox-prev');
    const lightboxNext = document.getElementById('lightbox-next');
    if(galleryItems && lightboxClose) {
        let currentIndex = 0;

        const openLightbox = (index) => {
            currentIndex = index;
            lightboxImage.src = galleryItems[currentIndex].querySelector('img').src;
            lightbox.style.display = 'flex';
        };

        const closeLightbox = () => {
            lightbox.style.display = 'none';
        };

        const showPrevImage = () => {
            currentIndex = (currentIndex > 0) ? currentIndex - 1 : galleryItems.length - 1;
            openLightbox(currentIndex);
        };

        const showNextImage = () => {
            currentIndex = (currentIndex < galleryItems.length - 1) ? currentIndex + 1 : 0;
            openLightbox(currentIndex);
        };

        galleryItems.forEach((item, index) => {
            item.addEventListener('click', () => openLightbox(index));
        });

        lightboxClose.addEventListener('click', closeLightbox);
        lightboxPrev.addEventListener('click', showPrevImage);
        lightboxNext.addEventListener('click', showNextImage);
        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) closeLightbox();
        });
    }
    
});



//closes the TOC mobile accordion so it won't overlap the headers on mobile
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
    document.querySelectorAll('.toc-accordion-mobile .toc-table-list a').forEach(tocLink => {
        tocLink.addEventListener('click', () => {
        const accordionTab = document.querySelector('.toc-accordion-mobile .tab-label');
        accordionTab.click();
        });
    });
  }, 1500);
});